import React, { FC, ReactNode } from 'react';
import { useTranslation } from 'react-i18next';

import { Button } from 'components';
import {
  EmptyStateContainer,
  EmptyStateIcon,
  EmptyStateTitle,
  EmptyStateDescription,
  EmptyStateButtonWrapper,
} from './styled';

interface EmptyStateProps {
  icon?: string | ReactNode;
  title: string;
  description?: string;
  button?: ReactNode;
  onClearSearch?: () => void;
  className?: string;
}

const EmptyState: FC<EmptyStateProps> = ({
  icon,
  title,
  description,
  button,
  onClearSearch,
  className,
}) => {
  const { t } = useTranslation();

  return (
    <EmptyStateContainer className={className}>
      {icon && <EmptyStateIcon>{icon}</EmptyStateIcon>}
      <EmptyStateTitle>{title}</EmptyStateTitle>
      {description && (
        <EmptyStateDescription>
          {description}
          {onClearSearch && (
            <EmptyStateButtonWrapper>
              <Button variant="default" width="100%" onClick={onClearSearch}>
                {t('communitySettings.clearSearch', 'Clear Search')}
              </Button>
            </EmptyStateButtonWrapper>
          )}
        </EmptyStateDescription>
      )}
      {button && <EmptyStateButtonWrapper>{button}</EmptyStateButtonWrapper>}
    </EmptyStateContainer>
  );
};

export default EmptyState;
